import React, { Component } from 'react';
import AboutMePage from 'components/AboutMePage/AboutMePage';
import GalleryOrganizer from 'components/GalleryPage/GalleryOrganizer';
import PaymentPage from 'components/PaymentPage/PaymentPage';
import ResumePage from 'components/ResumePage/ResumePage';
import Nav from 'components/Nav/Nav';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'styles/app.scss';

import { Route } from 'react-router-dom';

const homePath = '/';
const aboutPath = '/about';
const galleryPath = '/gallery';
const paymentPath = '/pay';
const resumePath = '/resume';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: props.location,
      collapsed: true,
    };
  }

  render() {
    const home = 
    <div className='homeContainer'>
      <div className='home'>
        <div className='header'>
          <img
              alt='Header'
              title='Header'
              src={require('static/misc/header.jpg')}
          />
        </div>
      </div>
    </div>;

    return (
      <div className='appContainer'>
        <Nav />
        <div className='app'>
          <Route exact path={homePath} render={() => (home)} />
          <Route path={aboutPath} render={() => <AboutMePage />} />
          <Route path={resumePath} render={() => <ResumePage />} />
          <Route path={paymentPath} render={() => <PaymentPage />} />
          <Route path={galleryPath} render={() => <GalleryOrganizer />} />
        </div>
        <div />
        <div className='copyright'>© April Brust 2019</div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/HomePage/App.js